import { render, staticRenderFns } from "./PersonalDataPage.vue?vue&type=template&id=7823a30a&scoped=true"
import script from "./PersonalDataPage.vue?vue&type=script&lang=js"
export * from "./PersonalDataPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataPage.vue?vue&type=style&index=0&id=7823a30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823a30a",
  null
  
)

export default component.exports